import React from "react";
import { Link } from "react-router-dom";
import Video from "../assets/globe.mp4";

export default function NotFoundHeader({ language }) {
  return (
    <header className="header">
      <div className="container">
        <div className="banner d-flex align-items-start justify-content-center flex-column">
          <h1>404</h1>
          <p>
            <span>Böyle bir sayfa yok.</span> Doğru teknolojiye ulaşmak için ana sayfaya geri dönebilirsin.
          </p>
          <Link to="/">Ana Sayfaya Dön</Link>
          <div className="video">
            <video autoPlay playsInline muted loop>
              <source src={Video} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </header>
  );
}
